import * as React from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import "antd/dist/antd.css";  // TODO: antd v5 drops this precompiled styles. Use components!
import "./Library.css";

import { RobotCard } from "../Card/RobotCard";
import { ToolCard } from "../Card/ToolCard";
import { LibData } from "../../utils/LibObjectsData";

// action to scroll to the robot name
window.addEventListener('load', () => {
    let showname = /n=([^&]+)/.exec(window.location.search);
    if (!showname) { return; }
    let robid = document.getElementById(showname[1]);
    if (!robid) { return; }
    //console.log("Scrolling to: " + showname[1])
    robid.scrollIntoView({ behavior: 'smooth', block: "center" });
});

const start = performance.now();

const objectCards = {};
Object.entries(LibData.DATA_ALL).map((entry) => {
    const [key, item] = [entry[0], entry[1]];

    objectCards[item["N"]] = <ToolCard
        category={item["MT"]}
        name={item["N"]}
        file={item["F"]}
        img={item["I"]} // Tools don't have lighter images
        brand={item["B"]}
        model={item["M"]}
        type={item["T"]}
        axes={item["A"]}
        reach={item["R"]}
        payload={item["P"]}
        weight={item["W"]}
        repeatability={item["E"]}
    />
});

console.log("Setup time (ms): " + (performance.now() - start));


export const ObjectLib = (props: any) => {
    const [init, setInit] = React.useState(true);
    
    const [range, setRange] = React.useState(20);

    const updateRange = () => {
        setRange(range + 20);
    };

    React.useEffect(() => {
        if (init) {
            // The following chceks won't work from parent iframe, i.e. library
            // if want to work, have to add extra code to receive params
            // from parent before check

            // Check if library is opened from RoboDK app
            // either from url query or cookie
            if (window.location.search.includes("RDK&")) {
                window.CookieHandler.setCookie("RDK-Available", "1", 730);
                window.Settings.open_in_rdk = true;
            } else {
                if (window.CookieHandler.isSet("RDK-Available")) {
                    window.Settings.open_in_rdk = true;
                }
            }

            // Check if library is opened from RoboDK Web
            if (window.location.search.includes("RoboDK-Web&")) {
                window.Settings.open_in_rdk = true;
                window.Settings.on_robodk_web = true;
            }

            let showname = /n=([^&]+)/.exec(window.location.search);

            if (showname == null) {
                setRange(range);
            } else {
                let rob_index = Object.entries(props.sortFilteredObjects).findIndex(
                    ([entry, index]) => entry == showname[1]
                )

                setRange(range + rob_index);
            }
            setInit(false);
        }
    });

    return (
        <>
            <div className="library-robots">
                {/*
                    Commented because some of the trans;ations aren't available
                    and is this being used? It doesn't show any difference without it
                */}
                {/* <div className="section-top-hidden">
                    <label className="float-left" htmlFor="sortBy">
                        {t('library.sortBy')})}
                    </label>
                    <Dropdown className="float-left">
                        <Dropdown.Toggle className="dropdown-toggle">
                            {t(sortDDStringA) +
                                " (" +
                                t(sortDDStringB) +
                                "-" +
                                t(sortDDStringC) +
                                ")"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="sort-dd-menu">
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Name ASC"
                            >
                                {t('robot.attributes.name')}) + " "}(A-Z)
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Name DESC"
                            >
                                {t('robot.attributes.name')}) + " "}(Z-A)
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Reach ASC"
                            >
                                {t('robot.attributes.reach')}) +
                                    " (" +
                                    t() +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Reach DESC"
                            >
                                {t('robot.attributes.reach')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Payload ASC"
                            >
                                {t('robot.attributes.payload')}) +
                                    " (" +
                                    {t('library.low')}) +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Payload DESC"
                            >
                                {t('robot.attributes.payload')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="WeightTotal ASC"
                            >
                                {t('robot.attributes.weight')}) +
                                    " (" +
                                    {t('library.low')}) +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="WeightTotal DESC"
                            >
                                {t('robot.attributes.weight')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Repeatability ASC"
                            >
                                {t('robot.attributes.repeatability')}) +
                                    " (" +
                                    {t('library.low')}) +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Repeatability DESC"
                            >
                                {t('robot.attributes.repeatability')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className="float-clear"></div>
                </div> */}
                <InfiniteScroll
                    style={{ 
                        overflow: 'visible'
                    }}
                    dataLength={range}
                    next={updateRange}
                    hasMore={true}
                    loader={<h4></h4>}
                    endMessage={''}
                >
                    <div className="row cards">
                        {props.noObjectsMessage != "" && (
                            <h4>{props.noObjectsMessage}</h4>
                        )}
                    
                        {/* {props.sortFilteredRobots.map((robot) => { */}
                        {/* {props.sortFilteredRobots.slice(0, range).map((robot) => { */}
                        {Object.entries(props.sortFilteredObjects).slice(0, range).map((entry) => {
                            const [key, object] = [entry[0], entry[1]];

                            return (
                                <div
                                    key={"row-" + object["N"]}
                                    className="card g-2 col col-12 col-sm-6 col-md-4 col-xl-3 col-xxl-2"
                                >
                                    {objectCards[object["N"]]}
                                </div>
                            )
                        })}
                    </div>
                </InfiniteScroll>
            </div>
        </>
    );
};
